// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90319a33","455":"735c29e3","977":"11220c0d"}[chunkId] + ".chunk.js";
};